import RangeSlide from "@components/atoms/RangeSlide";
import { PRODUCT_PRICE_FILTER_STEP } from "@const/products.const";
import { RangeValues } from "@interfaces/components/range-slide.interface";
import { numberToMoneyString } from "@utils/numbers.util";
import { useState } from "react";

interface Props {
  orgPriceRange: RangeValues;
  defaultPriceRange: RangeValues | undefined;
  onFilterChange: ({ start, end }: RangeValues) => void;
}

const PriceFilter = ({
  orgPriceRange,
  defaultPriceRange,
  onFilterChange,
}: Props) => {
  const [rangeValues, setRangeValues] = useState<RangeValues>({
    start: defaultPriceRange?.start ?? orgPriceRange?.start,
    end: defaultPriceRange?.end ?? orgPriceRange?.end,
  });

  const handleRangeValuesUpdate = ({ start, end }: RangeValues) => {
    setRangeValues({ start, end });
    onFilterChange({ start, end });
  };

  return (
    <div className="filter-price rounded-2">
      <div className="filter-title">
        <h3>ช่วงราคา</h3>
      </div>
      <div className="slider-range pt-1">
        <RangeSlide
          step={PRODUCT_PRICE_FILTER_STEP}
          min={
            defaultPriceRange && defaultPriceRange.start < orgPriceRange.start
              ? defaultPriceRange.start
              : orgPriceRange.start
          }
          max={
            defaultPriceRange && defaultPriceRange.end > orgPriceRange.end
              ? defaultPriceRange.end
              : orgPriceRange.end
          }
          onChange={handleRangeValuesUpdate}
          defaultRangeValues={defaultPriceRange}
        />
        <div className="d-flex pt-2">
          <span>ราคา</span>
          <span className="mx-2">
            ฿{numberToMoneyString(rangeValues.start, 0)}
          </span>
          <span>-</span>
          <span className="mx-2">
            ฿{numberToMoneyString(rangeValues.end, 0)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PriceFilter;
